import { ACTIONS } from './states';
export const reducer = (pluginState, action) => {
  var _pluginState$proactiv;
  switch (action.type) {
    case ACTIONS.UPDATE_PLUGIN_STATE:
      return {
        ...pluginState,
        ...action.data,
        dismissedWords: !!action.data.newDismissedWord ? pluginState.dismissedWords.add(action.data.newDismissedWord) : pluginState.dismissedWords
      };
    case ACTIONS.TOGGLE_SPELLING_AND_GRAMMAR_ENABLED:
      return {
        ...pluginState,
        isSpellingAndGrammarEnabled: !pluginState.isSpellingAndGrammarEnabled
      };
    case ACTIONS.UPDATE_BLOCKS_DIFF_OBJECTS:
      return {
        ...pluginState,
        proactiveAIBlocks: (_pluginState$proactiv = pluginState.proactiveAIBlocks) === null || _pluginState$proactiv === void 0 ? void 0 : _pluginState$proactiv.map(block => {
          if (action.data.blocksDiffObjectsByBlockId.has(block.id)) {
            block.diffObjects = action.data.blocksDiffObjectsByBlockId.get(block.id);
            block.needSpellingAndGrammarCheck = false;
          }
          return block;
        })
      };
    default:
      return pluginState;
  }
};